export const influencerListStyles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: { xs: "flex-start", lg: "center" },
    width: "100%",
    overflowX: "auto",
    whiteSpace: "nowrap",
    padding: "10px 0",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  buttonContainer: {
    display: "inline-flex",
    flexWrap: "nowrap",
    gap: "5px",
  },
  categoryButton: {
    whiteSpace: "nowrap",
    padding: "2rem inherit",
  },
  categoryInnerBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
    width: "fit-content",
  },
  categoryTypography: {
    fontSize: "14px",
    fontWeight: 600,
  },
};
